import { render } from "./ShiftSlotButton.vue?vue&type=template&id=5aefc55a&scoped=true"
import script from "./ShiftSlotButton.vue?vue&type=script&lang=js"
export * from "./ShiftSlotButton.vue?vue&type=script&lang=js"

import "./ShiftSlotButton.vue?vue&type=style&index=0&id=5aefc55a&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aefc55a"]])

export default __exports__